import React from "react";
import { Link } from "react-router-dom";
import "./Button.css";
import classNames from "classnames";

export default ({ path, active, title }) => {
  const classes = classNames({
    OptionButton: true,
    "OptionButton--active": active === true
  });

  return (
    <Link to={path}>
      <div className={classes}>{title}</div>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/Button.js